// @ts-nocheck

import { v4 } from 'uuid';

import Reporter from '../../../managers/reporter';

// object for storing reference to our promise-object
const promises = {};

const oldPromises = {};

// this function is called by native methods
// @param promiseId - id of the promise stored in global variable promises
export const callJs = (promiseId, data, error) => {
  console.debug('[BRIDGE] callJs ', promiseId, data);
  const promise = promises[promiseId];
  try {
    promise.resolve({ data, error });
    // remove reference to stored promise
    oldPromises[promiseId] = { request: promise.request, data, error };
    delete promises[promiseId];
  } catch (e) {
    Reporter.sendReport({
      message: 'Error in callJs callback ios',
      request: promise?.request,
      error: e?.message,
      callJsData: data,
      callJsError: error,
      oldPromise: oldPromises[promiseId],
    });
  }
};

export const callNative = (request, payload) => {
  console.debug('[BRIDGE] callNative', request, payload);
  return new Promise((resolve, reject) => {
    // we generate a unique id to reference the promise later from native function
    const promiseId = v4();
    // save reference to promise in the global variable
    promises[promiseId] = { resolve, reject, request };

    try {
      window.webkit.messageHandlers.onNativeCalled.postMessage({ promiseId, request, payload });
    } catch (err) {
      console.error(err);
    }
  });
};
